import { render, staticRenderFns } from "./AddAiApp.vue?vue&type=template&id=6d066bbd"
import script from "./AddAiApp.vue?vue&type=script&lang=js"
export * from "./AddAiApp.vue?vue&type=script&lang=js"
import style0 from "./AddAiApp.vue?vue&type=style&index=0&id=6d066bbd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports